import { MapPin, Award, DollarSign, Bell, HeadphonesIcon } from "lucide-react";

const reasons = [
  {
    icon: MapPin,
    title: "Locally Owned & Operated",
    description: "We're part of your community, committed to providing the best service to our neighbors.",
  },
  {
    icon: Award,
    title: "Experienced Grooming Team",
    description: "Our skilled groomers have years of experience handling dogs and cats of all breeds.",
  },
  {
    icon: DollarSign,
    title: "Transparent Pricing",
    description: "No hidden fees. You'll always know the cost upfront before we begin any service.",
  },
  {
    icon: Bell,
    title: "Appointment Reminders",
    description: "Never miss an appointment with our convenient reminder system via text or email.",
  },
  {
    icon: HeadphonesIcon,
    title: "Friendly Support",
    description: "Have questions? Our friendly team is always here to help with any concerns.",
  },
];

export const WhyChooseUsSection = () => {
  return (
    <section
      id="why-choose-us"
      data-testid="why-choose-us-section"
      className="py-16 md:py-24 bg-white"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Why Choose Cozy Nests?
          </h2>
          <div className="section-divider mx-auto mb-6"></div>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            We're dedicated to making your pet look and feel their best while ensuring their comfort and safety.
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div
                key={index}
                data-testid={`why-choose-${index}`}
                className="group p-6 bg-gradient-to-br from-sky-50 to-white rounded-2xl border border-sky-100 hover-lift animate-fade-in-up"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center mb-5 shadow-md group-hover:shadow-lg transition-shadow">
                  <Icon className="w-7 h-7 text-sky-600" />
                </div>
                <h3 className="font-heading text-xl font-bold text-slate-900 mb-3">
                  {reason.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
